import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router } from 'react-router-dom';
import './Styles/Toyota.scss'
import AppVars from './AppVars.js';
import Logger from './Logger.js';

let appVars = AppVars.getInstance();
appVars.setEnv();
appVars.setData(appVars.getEnv());

let logger = Logger.getInstance();
logger.setEnv();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Router>
    <App />
  </Router>
);
// Optional: Enable service worker
serviceWorker.unregister(); // Or serviceWorker.register() if you want PWA capabilities